import {useStore} from "vuex";
import {computed} from "vue";

const useHealthcheckStore = () => {
  const store = useStore();

  const activeTab = computed(() => store.getters['backlinkHealthcheck/activeTab']);
  const maxDomainAuthority = computed(() => store.getters['backlinkHealthcheck/maxDomainAuthority']);
  const search = computed(() => store.getters['backlinkHealthcheck/search']);

  return {
    activeTab,
    maxDomainAuthority,
    search,
  };
};

export default useHealthcheckStore;
